'use client'

import { isNull } from 'lodash-es'
import { ComponentProps } from 'react'

import { Icon, Sheet } from '@/shared/ui'
import { MobileHeader as MobileHeaderWidget } from '@/widgets/common'

type Props = ComponentProps<'div'> & {
  roomUrl: string | null
  roomName: string
  onShared?: () => void
}

export const MobileHeader = ({
  roomUrl,
  roomName,
  onShared,
  ref,
  ...restProps
}: Props) => {
  const hasRoomUrl = !isNull(roomUrl)

  return (
    <Sheet.Header
      className="h-14 flex-row justify-between bg-white p-4"
      ref={ref}
      {...restProps}
    >
      <Sheet.Close asChild>
        <button>
          <Icon
            name="arrow-left"
            size={24}
            strokeWidth={1.5}
            className="text-black"
          />
          <span className="sr-only">이전으로 돌아가기</span>
        </button>
      </Sheet.Close>
      <Sheet.Title className="sr-only">이미지 갤러리</Sheet.Title>
      {hasRoomUrl && (
        <MobileHeaderWidget.Share title={roomName} onShared={onShared} />
      )}
    </Sheet.Header>
  )
}
